
import { Announcement } from '../../types';
import { synczbase } from '../../lib/synczbase';

export const getAnnouncements = async (userId: string): Promise<Announcement[]> => {
    try {
        const snap = await synczbase.query("SELECT announcements FROM users WHERE id = $1 LIMIT 1", [userId]);
        if (snap && snap.length > 0) {
            const data = snap[0];
            return (data?.announcements || []) as Announcement[];
        }
    } catch (e) {
        console.warn("Error fetching announcements:", e);
    }
    return [];
};

export const createAnnouncement = async (
    userId: string, 
    content: string, 
    linkedService?: {id: string, title: string},
    schedule?: { start?: number, end?: number },
    bgColor?: string
) => {
    const existing = await getAnnouncements(userId);
    if (existing.length >= 3) {
        throw new Error("Maximum of 3 announcements allowed (Active or Scheduled). Please delete one.");
    }

    const now = Date.now();
    const start = schedule?.start || now;
    const active = start <= now;

    const newAnn = {
        id: `ann_${now}`,
        userId,
        content,
        bgColor: bgColor || 'PURPLE',
        linkedServiceId: linkedService?.id || null,
        linkedServiceName: linkedService?.title || null,
        active,
        scheduledStart: start,
        scheduledEnd: schedule?.end || null,
        createdAt: now
    };

    const updated = [newAnn, ...existing];
    await synczbase.query(
        `UPDATE users SET announcements = $1 WHERE id = $2`,
        [JSON.stringify(updated), userId]
    );
};

export const deleteAnnouncement = async (id: string, userId?: string) => {
    if (!userId) return; // Need userId to know which document
    const existing = await getAnnouncements(userId);
    const updated = existing.filter(a => a.id !== id);
    await synczbase.query(
        `UPDATE users SET announcements = $1 WHERE id = $2`,
        [JSON.stringify(updated), userId]
    );
};
